module.exports = __webpack_public_path__ + "img/podcast 2.46d10900.png";